import { subscribe } from "@wordpress/data";

const unsubscribe = subscribe(() => {
	const backButton = document.querySelector(
		".edit-post-fullscreen-mode-close"
	) as HTMLElement;
	if (!backButton) return;
	if (
		backButton.getAttribute("href") ===
		"edit.php?post_type=mzb-builder-template"
	) {
		backButton.setAttribute(
			"href",
			"admin.php?page=magazine-blocks#/site-builder"
		);
	}
});
